import { render } from "./SettingsAppearance.vue?vue&type=template&id=7765ca8d"
import script from "./SettingsAppearance.vue?vue&type=script&lang=js"
export * from "./SettingsAppearance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__